<div class="d-flex gap-1 align-items-center">
    @if (connection && connection.person) {
        <adapt-link-person [person]="connection.person"
                           [showImage]="true"
                           [showPopover]="false"
                           [linkDisabled]="isEditing"
                           imageSize="sm"></adapt-link-person>
        @if (roleConnection) {
            <adapt-display-role-connection-handover-status [roleConnection]="roleConnection">
            </adapt-display-role-connection-handover-status>
        }
    }

    @if (roleConnection && isEditing) {
        <div class="ms-auto d-flex gap-1 align-items-center">
            <adapt-menu [items]="menuItems"
                        data-test="team-role-connection-menu"></adapt-menu>
        </div>
    }
</div>
